import { render, staticRenderFns } from "./FileStatus.vue?vue&type=template&id=c5e764dc&"
import script from "./FileStatus.vue?vue&type=script&lang=js&"
export * from "./FileStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBadge})
